// reCAPTCHA v3's token, once its script is ready.
//
// The script loads with the page (GoogleReCaptchaProvider), so a quick visitor can press Continue
// or Send code before it is there. Asking right away sent no token, and the API's "Missing
// recaptcha" showed as "We couldn't verify that you're human" to someone who only clicked fast.
// Found by the golden path on integration, 2026-10-31.

type Execute = ((action: string) => Promise<string>) | undefined;

const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

// How long a press waits for the script: on integration it is ready 3-5 s after the form shows
// (measured 2026-10-31), longer on a slow phone. Past that the page says what it says today.
export const RECAPTCHA_READY_TIMEOUT_MS = 20000;
const POLL_MS = 200;

// Waits for reCAPTCHA to be ready, then asks for a token. "" when it never got ready or the
// token couldn't be had. `getExecute` reads the hook's latest value (a ref), since the value the
// press started with stays empty while the script loads.
export const recaptchaTokenWhenReady = async (
  getExecute: () => Execute,
  action: string,
  timeoutMs: number = RECAPTCHA_READY_TIMEOUT_MS
): Promise<string> => {
  const deadline = Date.now() + timeoutMs;
  let execute = getExecute();
  while (!execute && Date.now() < deadline) {
    await wait(POLL_MS);
    execute = getExecute();
  }
  if (!execute) return "";
  try {
    return (await execute(action)) || "";
  } catch (e) {
    return "";
  }
};
